export default "__VITE_ASSET__D4Y850kq__"